module.exports = __webpack_public_path__ + "img/symbol_1.935708f0.png";